import React, { PureComponent, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as instructorActions from '../../_actions/roster.actions'
import _ from 'lodash'
import 'react-day-picker/lib/style.css'
import { SearchOutlined } from '@ant-design/icons'
import { Select, DatePicker, Col, Row } from 'antd'
import { Formik, ErrorMessage } from 'formik'
import { Form, Field } from 'formik-antd'

import { Divider } from 'primereact/divider'

import Draggable from 'react-draggable'
import Modal from 'react-bootstrap/Modal'
import DraggableModalDialog from '../common/DraggableModalDialog'
import { formatDate, parseDate } from 'react-day-picker/moment'
import ModalSMS from '../settings/ModalSMS'

// import TimePicker from 'react-times';
import moment from 'moment'

// CSS
import './ETimeForm.css'

import validate from './validation/validate-yup'
import getValidationSchema from './validation/getValidationSchema-yup'
import TimeUtils from '../../utils/TimeUtils'

import { Calendar } from 'primereact/calendar';



class RosterForm extends PureComponent {
    state = {
        currentMonth: new Date(),
        selectedDate: new Date(),
        selectedOption: null,
        loaded: false,
        events: [],
        showModal: false,
        showNotifyWindow: false,
        hourStart: null,
        minuteStart: null,
        meridiemStart: null,
        focusedStart: false,
        timezoneStart: null,
        showTimezoneStart: false,
        hourEnd: null,
        minuteEnd: null,
        meridiemEnd: null,
        focusedEnd: false,
        timezoneEnd: null,
        showTimezoneEnd: false,
        showTimeSelector: false,
        showDuration: false,
        show: false,
        disableRemove: false,
        employee: '',
        event: {},
        actions: {},
        readOnly: false,
        leaveType: false,
        multipleDays: false,
        currentEmployee: null,
        disableEmployee: false,
    }

    

    handleClose = () => {
        this.setState({ show: false })
    }

    handleShow = () => {
        this.setState({ show: true })
    }

    // componentWillReceiveProps = props => {
    //     this.setState(props)
    // }
    componentDidMount() {
        // addLocale('en-NZ', {
        //     firstDayOfWeek: 1,
        //     dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        //     dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        //     dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        //     monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        //     monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        //     today: 'Hoy',
        //     clear: 'Limpiar',
        //     //...
        // });

        // locale('en-NZ')

        // disableRemove = _.isEmpty(this.props.event.id)
        this.setState({ disableRemove: _.isEmpty(this.props.event.id) })
        const actionTypeElm = document.getElementById('actionType')
        // actionTypeElm.getElementsByTagName('input')[0].readOnly = true

        // disable update by action type == 14 (normal work)
        const user = JSON.parse(localStorage.getItem('user'))
        // if (user.role !== 0) {
        //     const actionType = this.props.event.actionType.value
        // if (99 == actionType && this.props.event.existing) {
        //     // disable update
        //     this.setState({ readOnly: true })
        // }
        // }

        if (this.props.readOnly) {
            this.setState({ readOnly: true })
        }

        if (this.props.event.source === 'timesheet') {
            this.setState({ readOnly: true })
        }

        // const leave = this.props.event.actionType.value < 99 ? true : false
        // this.setState({ leaveType: leave })
    }

    onTimeChangeStart = options => {
        const { hour, minute, meridiem } = options

        this.setState({
            hourStart: hour,
            minuteStart: minute,
            meridiemStart: meridiem,
        })
    }

    onFocusChangeStart = focusedStart => {
        this.setState({ focusedStart })
    }

    onTimeChangeEnd = options => {
        const { hour, minute, meridiem } = options

        this.setState({
            hourEnd: hour,
            minuteEnd: minute,
            meridiemEnd: meridiem,
        })
    }

    onFocusChangeEnd = focusedEnd => {
        this.setState({ focusedEnd })
    }

    // handleActionTypeChange = selectedOption => {
    //     this.setState({ selectedOption })
    //     console.log(`Option selected:`, selectedOption)
    // }

    castToViewModel = (data, employeeId) => {
        const vm = {}
        vm.id = this.props.event.id || ''
        vm.Title = data.title

        // const start = _.head(data.range)
        // const end = _.last(data.range)
        // vm.StartDate = moment(TimeUtils.combineDateNTime(start, data.startTime))
        // vm.EndDate = moment(TimeUtils.combineDateNTime(end, data.endTime))
        vm.StartDate = data.startDate
        vm.EndDate = data.endDate
        vm.ActionType = data.actionType.value
        vm.ActionHours = data.duration
        vm.allDay = true
        vm.Note = data.note
        vm.Status = 'edit'
        vm.Break = data.break
        vm.EmployeeID = employeeId
        vm.Hours = data.hours

        return vm
    }

    castToModel = data => {
        const vm = {}

        vm.employees = data.employee
        vm.startTime = data.startTime
        vm.endTime = data.endTime
        vm.PayrollEmpRosterStartDate = data.startDate
        vm.PayrollEmpRosterEndDate = data.endDate
        vm.PayrollEmpRosterActionNotes = data.note || ''
        vm.PayrollEmpRosterBreakMinute = _.toNumber(data.break) || 0
        vm.repeatEnd = data.repeatEnd

        return vm
    }

    castToUpdateModel = data => {
        const vm = {}

        vm.PayrollEmpRosterAutoID = data.id
        vm.PayrollEmpRosterEmployeeID = data.employeeID
        vm.PayrollEmpRosterStartDate = data.startDate
        vm.PayrollEmpRosterEndDate = data.endDate
        vm.PayrollEmpRosterActionNotes = data.note || ''
        vm.PayrollEmpRosterBreakMinute = _.toNumber(data.break) || 0
        vm.PayrollEmpRosterDispTitle = data.title

        return vm
    }


    handleETimeSubmitMulti = (data, setSubmitting) => {
        const { id } = data

        const selectedEmployees = this.props.selectedEmployees

        const startDate = data.startDate

        let start = moment(
            TimeUtils.combineDateNTime(startDate, data.startTime)
        )
        let end = moment(TimeUtils.combineDateNTime(startDate, data.endTime))

        if (end.isSameOrBefore(start)) {
            end = end.add(1, 'days')
        }

        data.startDate = start
        data.endDate = end

        // const payload = this.castToModel(data, selectedEmployees)
        // if id not defined, create
        if (!_.isNumber(id)) {
            const payload = this.castToModel(data, selectedEmployees)
            this.props.actions
                .addEvent(payload, this.props.weekView)
                .then(res => {
                    

                    if(this.props.onSubmitRefresh){
                        this.props.onSubmitRefresh()
                    }
                    
                })
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                    this.props.onHide()
                })
        } else {
            // update

            let employeeId = this.props.event.employeeID

            const emp = _.find(this.props.displayEmployees, {
                EmployeeAutoID: employeeId,
            })

            // data.startDate = moment(
            //     TimeUtils.combineDateNTime(start, data.startTime)
            // )
            // data.endDate = moment(TimeUtils.combineDateNTime(end, data.endTime))

            const startTime = data.startTime
            const endTime = data.endTime

            let title = `${startTime}-${endTime}:${emp.EmployeeFirstName} ${emp.EmployeeLastName}`
            data.title = title

            const payload = this.castToUpdateModel(data)
            payload.dateFrom = this.props.event.dateFrom
            payload.dateTo = this.props.event.dateTo

            this.props.actions
                .updateOne(payload, this.props.weekView)
                .then(res => {
                    
                    this.props.onSubmitRefresh()
                })
                .catch(error => {
                    console.log(`error=${error}`)
                })
                .finally(() => {
                    setSubmitting(false)
                    this.props.onHide()
                })
        }
    }

    onDelete = event => {
        this.handleShow()
    }

    onCancel = evt => {
        this.props.onHide()
    }

    showNotify = () => {
        this.setState({ showNotify: true })
    }

    closeNotify = () => {
        this.setState({ showNotify: false })
    }

    removeEvent = event => {
        this.props.actions
            .removeEventById(this.props.event.id, this.props.employee)
            .then(res =>
                _.head(document.getElementsByClassName('close')).click()
            )
            .catch(error => {
                console.log(`error=${error}`)
            })
    }

    handleActionTypeChange = (e, form) => {
        form.setFieldValue('actionType', e)
        const leave = e.value < 99 ? true : false
        this.setState({ leaveType: leave })
    }

    handleEmployeeChange = (e, form) => {
        form.setFieldValue('employee', e)
    }

    getEmployeeDefaultWorkHour = employeeId => {
        const employeeNormalWorkHours = this.props.payrollNormalWorkHour[
            employeeId
        ]
        if (!_.isEmpty(employeeNormalWorkHours)) {
            // year, month, date
            const evtYear = moment(this.props.event.start).year()
            const evtMonth = moment(this.props.event.start).month()
            const evtDate = moment(this.props.event.start).date()

            // local weekday
            const weekday = moment(this.props.event.start).weekday() + 1

            //PayrollEmpNormalWorkingHourStartTimeHour,PayrollEmpNormalWorkingHourStartTimeMinute

            const startTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeHour${weekday}`
                ]
            const startTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourStartTimeMinute${weekday}`
                ]

            //[PayrollEmpNormalWorkingHourFinishTimeHour],[PayrollEmpNormalWorkingHourFinishTimeMinute1]
            const finishTimeHour =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeHour${weekday}`
                ]
            const finishTimeMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourFinishTimeMinute${weekday}`
                ]
            //[PayrollEmpNormalWorkingHourBreakMinute]
            const breakMinute =
                employeeNormalWorkHours[
                    `PayrollEmpNormalWorkingHourBreakMinute${weekday}`
                ]

            // reset the start, end time
            //[year, month, day, hour, minute, second, millisecond]
            const evtStartTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                startTimeHour,
                startTimeMinute,
            ])
            const evtFinishTime = moment([
                evtYear,
                evtMonth,
                evtDate,
                finishTimeHour,
                finishTimeMinute,
            ])

            // eTimeRequest
            const startTime = TimeUtils.extractTime(evtStartTime.toDate())
            const endTime = TimeUtils.extractTime(evtFinishTime.toDate())

            return { start: startTime, finish: endTime }
        }
        return {}
    }

    handlePeriodChange = (dates, dateStrings, form) => {
        form.setFieldValue('range', dates)
        const a = _.head(dates)
        const b = _.last(dates)
        const days = b.diff(a, 'days')
        if (days >= 1) {
            this.setState({ multipleDays: true })
        } else {
            this.setState({ multipleDays: false })
        }
    }

    onChange = (value, dateString) => {
        console.log('Selected Time: ', value)
        console.log('Formatted Selected Time: ', dateString)
    }
    onOk = value => {
        console.log('onOk: ', value)
    }

    onStartDateChange = (date, dateString, etimeForm) => {
        etimeForm.setFieldValue('startDate', date)
    }
    onEndDateChange = (date, dateString, etimeForm) => {
        etimeForm.setFieldValue('repeatEnd', date)
    }
    displayEmployees = () => {
        const empOption = this.props.displayEmployees.map(emp => {
            let o = {}
            o.label = emp.EmployeeName
            o.value = emp.key
            return o
        })

        return empOption
    }

    handleChange = value => {}

    periodEndingChange = value => {
        console.log(`selected ${value}`)
    }

    validateEmail = value => {
        let error
        if (!value) {
            error = 'Required'
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            error = 'Invalid email address'
        }
        return error
    }

    validateFields = (values, props) => {
        const errors = {}

        // validate employee selection
        if (_.isArray(values.employee) && values.employee.length == 0) {
            errors.employee = 'Required'
        }

        // validate startTime
        if (_.isEmpty(values.startTime)) {
            errors.startTime = 'Invalid time'
        }

        // validate endTime
        if (_.isEmpty(values.endTime)) {
            errors.endTime = 'Invalid time'
        }

        // validate start date
        if (_.isEmpty(values.startDate)) {
            errors.startDate = 'Invalid date'
        } else if (!values.startDate.isValid()) {
            errors.startDate = 'Invalid date'
        }

        // validate repeatEnd
        if (!_.isEmpty(values.repeatEnd) && !values.repeatEnd.isValid()) {
            errors.repeatEnd = 'Invalid date'
        }

        // start date <= repeat end date
        if (!_.isEmpty(values.startDate) && values.startDate.isValid()) {
            if (!_.isEmpty(values.repeatEnd) && values.repeatEnd.isValid()) {
                const start = values.startDate
                const end = values.repeatEnd

                if (moment(end).isSameOrBefore(start, 'day')) {
                    errors.repeatEnd =
                        'Repeat end date should be after start date'
                }
            }
        }

        return errors
    }

    render() {
        const startDate = moment(this.props.event.dateFrom)

        const initialValues = {
            id: this.props.event.id,
            startDate: startDate,
            startTime: this.props.event.startTime,
            endTime: this.props.event.endTime,
            // duration: this.props.event.duration,
            // hours: this.props.event.hours || 0,
            break: this.props.event.break || 0,
            title: this.props.event.Title,
            note: this.props.event.Note,
            employeeID: this.props.event.employeeID,
            existing: this.props.event.existing,
        }

        if (this.props.event.dateTo != undefined) {
            const endDate = moment(this.props.event.dateTo)
            initialValues.repeatEnd = endDate
        }

        const showEmployee = this.props.showEmployee
        let employeeOptions = []
        if (showEmployee) {
            const empOption = this.props.displayEmployees.map(emp => {
                let o = {}
                o.label = emp.EmployeeName
                o.value = emp.EmployeeAutoID
                return o
            })
            employeeOptions = empOption

            if (_.isNumber(this.props.event.id)) {
                const employee = _.find(empOption, {
                    value: this.props.event.employeeID,
                })

                initialValues.employee = [employee.value]

                // this.setState({ disableEmployee: true })
            } else {
                initialValues.employee = this.props.selectedEmployees

                // const employeeID = _.head(this.props.selectedEmployees).code

                // const { start, finish } = this.getEmployeeDefaultWorkHour(
                //     employeeID
                // )
                // initialValues.startTime = start
                // initialValues.endTime = finish
            }
        }

        const { readOnly } = this.state
        return (
            <div>
                <Formik
                    initialValues={initialValues}
                    // validate={validate(getValidationSchema)}
                    // validationSchema={getValidationSchema}
                    validate={this.validateFields}
                    onSubmit={(values, { setSubmitting }) => {
                        setTimeout(() => {
                            this.handleETimeSubmitMulti(values, setSubmitting)
                        }, 400)
                    }}
                >
                    {etimeForm => (
                        <Form layout="vertical">
                            <Row gutter={{ md: 24 }}>
                                <Col xs={24} sm={24} md={12} lg={12}>
                                    <Form.Item
                                        name="employee"
                                        label="Employee"
                                        initialValue="week"
                                    >
                                        <Select
                                            id="employee"
                                            name="employee"
                                            dropdownStyle={{ zIndex: 1102 }}
                                            mode="multiple"
                                            allowClear
                                            placeholder="Select employees"
                                            defaultValue={[]}
                                            onChange={e =>
                                                this.handleEmployeeChange(
                                                    e,
                                                    etimeForm
                                                )
                                            }
                                            options={this.displayEmployees()}
                                            disabled={
                                                this.props
                                                    .disableEmployeeSelection
                                            }
                                            value={etimeForm.values.employee}
                                            maxTagCount="responsive"
                                            filterOption={(input, option) =>
                                                (option?.label ?? '')
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    )
                                            }
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            {!this.state.leaveType && (
                                <div className="row ">
                                    <div className="col-xs-6 col-sm-6 col-md-6 form-group padright15">
                                        <label className="col-xs-4 col-sm-4 col-md-4 control-label">
                                            Start:
                                            <span className="text-danger ">
                                                &nbsp;*&nbsp;
                                            </span>
                                        </label>
                                        <div className="col-xs-8 col-sm-8 col-md-8">
                                            {readOnly ? (
                                                etimeForm.values.startTime
                                            ) : (
                                                <div>
                                                    <Field
                                                        id="startTime"
                                                        className="form-control"
                                                        type="time"
                                                        name="startTime"
                                                        onChange={
                                                            etimeForm.handleChange
                                                        }
                                                        onBlur={
                                                            etimeForm.handleBlur
                                                        }
                                                        value={
                                                            etimeForm.values
                                                                .startTime
                                                        }
                                                        readOnly={readOnly}
                                                    />
                                                    <div className="errorMsg">
                                                        <ErrorMessage name="startTime" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xs-6 col-sm-6 col-md-6 form-group ">
                                        <label className="col-xs-4 col-sm-4 col-md-4 control-label">
                                            Until:
                                            <span className="text-danger">
                                                &nbsp;*&nbsp;
                                            </span>
                                        </label>
                                        <div className="col-xs-8 col-sm-8 col-md-8">
                                            {readOnly ? (
                                                etimeForm.values.endTime
                                            ) : (
                                                <div>
                                                    <Field
                                                        id="endTime"
                                                        className="form-control"
                                                        type="time"
                                                        name="endTime"
                                                        onChange={
                                                            etimeForm.handleChange
                                                        }
                                                        onBlur={
                                                            etimeForm.handleBlur
                                                        }
                                                        value={
                                                            etimeForm.values
                                                                .endTime
                                                        }
                                                        readOnly={readOnly}
                                                    />
                                                    <div className="errorMsg">
                                                        <ErrorMessage name="endTime" />
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {!this.state.leaveType && (
                                <div className="row">
                                    <div className="col-xs-6 col-sm-6 col-md-6 form-group padright15">
                                        <label className="col-xs-3 col-sm-4 col-md-4 control-label">
                                            Break:{' '}
                                        </label>
                                        <div className="col-xs-8 col-sm-8 col-md-8">
                                            {readOnly ? (
                                                etimeForm.values.break
                                            ) : (
                                                <Field
                                                    id="break"
                                                    className="form-control"
                                                    type="number"
                                                    name="break"
                                                    onChange={
                                                        etimeForm.handleChange
                                                    }
                                                    onBlur={
                                                        etimeForm.handleBlur
                                                    }
                                                    value={
                                                        etimeForm.values.break
                                                    }
                                                    readOnly={readOnly}
                                                />
                                            )}
                                            {etimeForm.errors.break &&
                                                etimeForm.touched.break && (
                                                    <div className="errorMsg">
                                                        {etimeForm.errors.break}
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="row">
                                <div className=" col-sm-12 form-group5">
                                    <label className=" col-sm-2 col-md-2 control-label">
                                        Job Detail:
                                    </label>
                                    <div className="col-sm-10 col-md-10">
                                        {readOnly ? (
                                            etimeForm.values.note
                                        ) : (
                                            <textarea
                                                type="text"
                                                id="note"
                                                className="form-control textarea-size"
                                                placeholder="Enter Job Details"
                                                onChange={
                                                    etimeForm.handleChange
                                                }
                                                onBlur={etimeForm.handleBlur}
                                                value={etimeForm.values.note}
                                                readOnly={readOnly}
                                            />
                                        )}

                                        {etimeForm.errors.note &&
                                        etimeForm.touched.note ? (
                                            <div>{etimeForm.errors.note}</div>
                                        ) : null}

                                        <div className="errorMsg">
                                            <ErrorMessage name="note" />
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Row gutter={{ md: 24 }}>
                                <Col xs={8} sm={16} md={6} lg={6}>
                                    <Form.Item name="startDate" label="Date">
                                        

                                    <Calendar value={etimeForm.values.startDate.toDate()} onChange={(e) => ""} locale='en-NZ' />
        
                                        {/* <DatePicker
                                            name="startDate"
                                            popupStyle={{
                                                zIndex: 1102,
                                            }}
                                            onChange={(date, dateString) =>
                                                this.onStartDateChange(
                                                    date,
                                                    dateString,
                                                    etimeForm
                                                )
                                            }
                                            value={etimeForm.values.startDate}
                                        /> */}
                                        {/* {etimeForm.errors.startDate &&
                                            etimeForm.touched.startDate && (
                                                <div className="errorMsg">
                                                    {etimeForm.errors.startDate}
                                                </div>
                                            )} */}
                                    </Form.Item>
                                </Col>

                                {this.props.event.dateTo != undefined && (
                                    <Col xs={8} sm={16} md={6} lg={6}>
                                        <Form.Item
                                            name="repeatEnd"
                                            label="Repeat until"
                                        >
                                            <DatePicker
                                                name="repeatEnd"
                                                popupStyle={{
                                                    zIndex: 1102,
                                                }}
                                                onChange={(date, dateString) =>
                                                    this.onEndDateChange(
                                                        date,
                                                        dateString,
                                                        etimeForm
                                                    )
                                                }
                                                value={
                                                    etimeForm.values.repeatEnd
                                                }
                                            />
                                        </Form.Item>
                                    </Col>
                                )}
                            </Row>

                            {this.props.event.status == 1 ? (
                                <div />
                            ) : (
                                <div>
                                    <Divider />
                                    <div className="modal-footer">
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm-w m-2"
                                            onClick={this.onCancel}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success pull-left btn-sm-w m-2"
                                            disabled={etimeForm.isSubmitting}
                                        >
                                            Save
                                        </button>
                                    </div>
                                </div>
                            )}
                        </Form>
                    )}
                </Formik>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        displayEmployees: state.roster.displayEmployees,
        payrollDefaultWorkHour: state.payrollDefaultWorkHour,
        payrollNormalWorkHour: state.payrollNormalWorkHour,
        selectedEmployees: state.roster.selectedEmployees,
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(instructorActions, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(RosterForm)
